export const pricingItemsPath = '/settings/other?tab=pricingItems';
export const pricingRatesPath = '/settings/other?tab=pricingRates';
export const timeServicesPath = '/settings/other?tab=timeServices';

const legacyPricingTabs: Record<string, string> = {
  items: pricingItemsPath,
  rates: pricingRatesPath,
};

// Old /settings/pricing?tab=items|rates links now live under Global settings.
export const legacyPricingRedirect = (search: string): string | undefined => {
  const tab = new URLSearchParams(search).get('tab');
  return tab ? legacyPricingTabs[tab] : undefined;
};

const DATE_ONLY_PREFIX = /^\d{4}-\d{2}-\d{2}(?:T[^Z+-]*)?$/;

// Values without an offset are already calendar dates; offset values come from the local date picker.
export const toDateOnly = (value: string): string => {
  if (DATE_ONLY_PREFIX.test(value)) return value.slice(0, 10);
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value.slice(0, 10);
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${date.getFullYear()}-${month}-${day}`;
};

export const toConcreteTenantId = (
  tenantId: number | null | undefined
): number | undefined =>
  typeof tenantId === 'number' && Number.isInteger(tenantId) && tenantId > 0
    ? tenantId
    : undefined;
